import React from 'react';

const panelLayout = props => {
  return (
    <div className="panel panel-default panel-main">
      <div className="panel-custom-heading font-bold">
        {props.title}
      </div>
        {props.children}
    </div>
  );
};

export default panelLayout;